import React, { useState, useEffect } from "react";
import { Button, Table, Spinner } from "react-bootstrap";
import up_down_arrow from "../../../../Assets/svg/up_down_arrow.svg";
import up_arrow from "../../../../Assets/svg/up_down_arrow.svg";
import down_arrow from "../../../../Assets/svg/up_down_arrow.svg";
import action_icon_1 from "../../../../Assets/svg/tableData/action-icon-1.svg";
import action_icon_2 from "../../../../Assets/svg/tableData/action-icon-2.svg";
import user from "../../../../Assets/images/user.png";
import toast from "react-hot-toast";
import { del } from "../../../../helpers/api_helper";
import AddNewUser from "./Modal/AddNewUser";
import DeleteConfirmationModal from "../../../../components/DeleteConfirmation";
import { useSelector } from "react-redux";
import useCheckPermission from "../../../../hooks/useCheckPermission";

const TableData = ({ userData, setRefresh, handleSort, sortBy, orderBy }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("edit");
  const [selectedUserData, setSelectedUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);

  const hasUpdatePermission = useCheckPermission("user", "UPDATE");
  const hasDeletePermission = useCheckPermission("user", "DELETE");

  useEffect(() => {
    if (userData.length > 0) {
      setLoading(false);
    }
  }, [userData]);

  const handleDelete = async () => {
    try {
      const response = await del(`/user/admin/user/${userToDelete}`);
      if (response.success) {
        setRefresh(true);
        toast.success("User deleted successfully");
      } else {
        console.log(response.message);
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    } finally {
      setShowConfirm(false);
    }
  };

  const confirmDelete = (id) => {
    setUserToDelete(id);
    setShowConfirm(true);
  };

  const handleEdit = (data) => {
    setSelectedUserData(data);
    setModalMode("edit");
    setShowModal(true);
  };

  const getSortIcon = (field) => {
    if (sortBy === field) {
      return orderBy === "asc" ? up_arrow : down_arrow;
    }
    return up_down_arrow;
  };

  return (
    <>
      <AddNewUser
        showModal={showModal}
        setShowModal={setShowModal}
        setRefresh={() => setRefresh(true)}
        mode={modalMode}
        userData={selectedUserData}
      />

      <DeleteConfirmationModal
        show={showConfirm}
        onHide={() => setShowConfirm(false)}
        onConfirm={handleDelete}
      />

      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100px" }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <Table responsive>
          <thead>
            <tr>
              <th className="fw-normal border-0">
                <Button
                  className="border-0 p-0"
                  variant="transparent"
                  onClick={() => handleSort("name")}
                >
                  Full Name{" "}
                  <span className="icn ms-2">
                    <img src={getSortIcon("name")} alt="" />
                  </span>
                </Button>
              </th>
              <th className="fw-normal border-0">Email</th>
              <th className="fw-normal border-0">
                <Button
                  className="border-0 p-0"
                  variant="transparent"
                  onClick={() => handleSort("createdAt")}
                >
                  Created at{" "}
                  <span className="icn ms-2">
                    <img src={getSortIcon("createdAt")} alt="" />
                  </span>
                </Button>
              </th>
              <th className="fw-normal border-0">Status</th>
              <th className="fw-normal border-0">Verified</th>
              <th className="fw-normal border-0">Action</th>
            </tr>
          </thead>
          <tbody>
            {userData && userData.length > 0 ? (
              userData?.map((data, key) => (
                <tr key={key}>
                  <td>
                    <div className="d-flex align-items-center profile">
                      <div className="imgWrp rounded-circle me-2">
                        <img
                          src={user}
                          alt=""
                          className="img-fluid rounded-circle"
                          style={{ height: 40, width: 40 }}
                        />
                      </div>
                      <div className="content">
                        <p className="m-0 fw-sbold">{data?.name}</p>
                      </div>
                    </div>
                  </td>
                  <td>{data?.email}</td>
                  <td>{new Date(data?.createdAt).toLocaleString()}</td>
                  <td>
                    <span className="labelTag greenLabel text-capitalize">
                      {data.status}
                    </span>
                  </td>
                  <td>
                    <span className="labelTag greenLabel">
                      {data.isEmailVerified === true ? "Yes" : "No"}
                    </span>
                  </td>
                  <td>
                    <div className="d-flex align-items-center gap-10">
                      {hasUpdatePermission && <Button
                        className="border-0 p-0"
                        variant="transparent"
                        onClick={() => handleEdit(data)}
                      >
                        <img src={action_icon_1} alt="" />
                      </Button>}
                      {hasDeletePermission && <Button
                        className="border-0 p-0"
                        variant="transparent"
                        onClick={() => confirmDelete(data?._id)}
                      >
                        <img src={action_icon_2} alt="" />
                      </Button>}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8">No data available</td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default TableData;
